export interface VideoArticle {
  id: number;
  title: string;
  slug: string;
  category: string;
  thumbnail: string;
  duration: string;
  views: number;
  date: string;
  description: string;
  content: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export const videos: VideoArticle[] = [
  {
    id: 1,
    title: '某顶流明星深夜密会神秘女子，酒店同框画面曝光引发热议',
    slug: 'top-star-secret-date-exposed',
    category: 'celebrity',
    thumbnail: 'https://readdy.ai/api/search-image?query=Entertainment%20news%20scene%20at%20night%20with%20luxury%20hotel%20entrance%2C%20paparazzi%20style%20photography%2C%20dramatic%20street%20lighting%2C%20celebrity%20gossip%20atmosphere%2C%20warm%20urban%20night%20tones&width=800&height=450&seq=vid-thumb-01&orientation=landscape',
    duration: '12:36',
    views: 2895630,
    date: '2026-08-07',
    description: '近日有媒体拍到某顶流男星深夜与一名神秘女子共同进入某五星级酒店，两人举止亲密，直至次日清晨才分别离开。此事引发网友热议。',
    content: '<p>近日，有知名娱乐媒体独家拍到某顶流男明星深夜与一名神秘女子共同进入位于北京市中心的某五星级酒店。</p><p>据目击者透露，当晚约11点左右，该男星驾驶一辆黑色商务车抵达酒店地下停车场，随后一名身着白色连衣裙的女子从同一辆车中走出。两人在电梯间等候期间有说有笑，看起来相当熟络。</p><p>更令人关注的是，两人进入酒店后直至次日清晨7点左右才分别离开。该男星先行离开酒店，约半小时后该女子才独自搭乘出租车离开。</p><p>此消息一出，迅速在社交平台引发热议。有粉丝表示"坐等官宣"，也有网友质疑"这明显是炒作"。截至目前，该男星及其工作室尚未对此事做出任何回应。</p><p>业内人士分析认为，近期该男星新剧即将上线，此次"偶遇被拍"不排除是团队策划的营销事件。但无论如何，这一事件已经成为本周娱乐圈最热门的话题之一。</p>',
    tags: ['明星', '恋情曝光', '娱乐圈', '热门话题'],
    isHot: true,
    isNew: true,
  },
  {
    id: 2,
    title: '知名网红直播间口误说出商业机密，品牌方紧急公关删视频',
    slug: 'influencer-livestream-leak-secret',
    category: 'influencer',
    thumbnail: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20with%20ring%20light%20and%20camera%20setup%2C%20modern%20influencer%20workspace%2C%20dramatic%20moment%20captured%2C%20warm%20ambient%20lighting%2C%20professional%20streaming%20environment&width=800&height=450&seq=vid-thumb-02&orientation=landscape',
    duration: '08:15',
    views: 1672300,
    date: '2026-08-06',
    description: '拥有千万粉丝的知名带货主播在直播过程中不慎透露品牌未公开合作细节，引发行业震动，品牌方火速要求下架相关录播内容。',
    content: '<p>昨晚，拥有超过1500万粉丝的知名带货主播"XX姐"在例行直播中，不慎在介绍某美妆品牌产品时，透露了该品牌尚未对外公布的下一季度代言人计划。</p><p>据观看直播的网友录屏显示，主播在与助理对话时无意间提到"下个月XX（某国际影星）代言的海报已经拍完了"，随后意识到口误，迅速转移话题。但该片段已被大量网友截屏转发。</p><p>事发后不到两小时，该品牌方紧急联系直播平台，要求下架当晚直播回放视频。品牌公关团队也连夜发布声明，称"关于代言人的信息请以官方公布为准"，既未确认也未否认相关传闻。</p><p>业内营销专家表示，此类口误事件在直播电商行业并不罕见，但涉及国际品牌和一线明星的合作信息，影响面较大。该主播团队或将面临品牌方的违约金索赔。</p>',
    tags: ['网红', '直播翻车', '商业机密', '品牌代言'],
    isHot: true,
    isNew: true,
  },
  {
    id: 3,
    title: '某科技巨头内部邮件泄露：即将大规模裁员，涉及多个核心部门',
    slug: 'tech-giant-internal-layoff-email-leaked',
    category: 'tech',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20tech%20office%20interior%20with%20empty%20desks%20and%20dim%20lighting%2C%20corporate%20atmosphere%2C%20dramatic%20mood%2C%20professional%20photography%2C%20warm%20dark%20tones&width=800&height=450&seq=vid-thumb-03&orientation=landscape',
    duration: '15:42',
    views: 1920500,
    date: '2026-08-06',
    description: '一份据称来自某头部科技公司的内部全员邮件在社交平台疯传，邮件内容显示该公司将于下月启动大规模人员优化计划。',
    content: '<p>昨日晚间，一份据称来自某国内头部科技公司的内部邮件在多个社交平台和职场社区疯传。该邮件署名来自公司CEO，标题为"关于组织架构优化的重要通知"。</p><p>邮件内容显示，受宏观经济环境和行业竞争加剧影响，公司决定在下个月启动一轮大规模组织架构调整和人员优化计划，预计涉及研发、市场、运营等多个核心部门，裁员比例可能达到总员工数的15%-20%。</p><p>该邮件还提到，公司将按照劳动法规定给予被优化员工N+3的补偿方案，并协助进行再就业推荐。</p><p>截至目前，该公司官方尚未对此邮件内容做出回应。但有认证为该司员工的职场社区用户发帖称"消息基本属实，内部已经在传了"。</p><p>行业分析师指出，如果消息属实，这将是该行业今年以来最大规模的一轮裁员行动，可能引发连锁反应。</p>',
    tags: ['科技公司', '裁员', '内部邮件', '行业动态'],
    isHot: true,
    isNew: true,
  },
  {
    id: 4,
    title: '热门综艺节目录制现场爆发激烈冲突，导演组紧急暂停',
    slug: 'variety-show-fight-on-set',
    category: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=TV%20show%20production%20set%20with%20cameras%20and%20crew%20in%20chaotic%20scene%2C%20dramatic%20studio%20lighting%2C%20behind%20the%20scenes%20tension%2C%20cinematic%20atmosphere%2C%20warm%20dramatic%20tones&width=800&height=450&seq=vid-thumb-04&orientation=landscape',
    duration: '10:28',
    views: 3210500,
    date: '2026-08-05',
    description: '知名综艺节目最新一期录制过程中，两位嘉宾因游戏环节产生争执，情绪失控后爆发肢体冲突，节目组紧急叫停录制。',
    content: '<p>近日，国内某热门综艺节目在最新一期录制过程中发生意外事件。据现场观众爆料，两位常驻嘉宾在完成一个团队竞技游戏环节时因胜负问题发生口角，随后矛盾升级，双方情绪激动之下爆发了肢体冲突。</p><p>据现场目击者描述，冲突起因是其中一位嘉宾认为对方在游戏中存在违规行为，而对方则否认并反击称其"输不起"。双方你来我往，言辞越发激烈，最终其中一位嘉宾情绪失控，推搡了对方。</p><p>节目导演组立即介入并将双方分开，随后宣布暂停录制。据悉，当天原定还需录制三个环节，全部被迫取消。节目组事后已安排双方进行调解沟通。</p><p>事件曝光后，网友对此看法不一。有观众认为"综艺效果而已，都是演的"，也有网友表示"从现场视频看，不像是演的"。节目组官方暂未就此事发布正式声明。</p>',
    tags: ['综艺节目', '嘉宾冲突', '录制事故', '娱乐圈'],
    isHot: true,
    isNew: false,
  },
  {
    id: 5,
    title: '独家揭秘：某投资大佬背后的灰色产业链，涉案金额超百亿',
    slug: 'investment-tycoon-gray-industry-exposed',
    category: 'business',
    thumbnail: 'https://readdy.ai/api/search-image?query=Luxury%20office%20with%20financial%20documents%20scattered%20on%20desk%2C%20dramatic%20investigation%20scene%2C%20warm%20ambient%20lighting%2C%20business%20scandal%20atmosphere%2C%20editorial%20photography&width=800&height=450&seq=vid-thumb-05&orientation=landscape',
    duration: '22:15',
    views: 4532000,
    date: '2026-08-05',
    description: '深度调查揭露某知名投资大佬通过复杂的股权结构和空壳公司进行非法融资，涉案金额据估算超过百亿元人民币。',
    content: '<p>经过长达半年的深度调查，我们独家揭露了某知名投资界大佬背后隐藏的庞大灰色产业链条。</p><p>调查发现，该投资大佬通过在新加坡、开曼群岛等离岸金融中心注册的数十家空壳公司，构建了一套极其复杂的股权嵌套结构。通过这些公司，其在过去五年间进行了多轮疑似非法的融资活动，涉及资金据保守估算已超过百亿元人民币。</p><p>更令人震惊的是，多名知情人士透露，这些资金中有相当一部分流向了境外，且资金最终用途与向投资者承诺的项目严重不符。部分投资者已联合向监管部门举报，并向法院提起诉讼。</p><p>此外，调查还发现该大佬与多位政商界人士关系密切，通过利益输送获取了大量政策便利。目前相关部门已启动调查程序。</p><p>此事件被视为近年来金融投资领域最大的丑闻之一，对整个行业的信誉造成了严重冲击。</p>',
    tags: ['投资大佬', '灰色产业', '金融调查', '深度报道'],
    isHot: true,
    isNew: false,
  },
  {
    id: 6,
    title: '热门古装剧男主角被曝片场耍大牌，剧组工作人员集体吐槽',
    slug: 'actor-diva-behavior-on-set',
    category: 'entertainment',
    thumbnail: 'https://readdy.ai/api/search-image?query=Film%20production%20set%20with%20period%20costume%20drama%20props%2C%20Chinese%20historical%20drama%20behind%20the%20scenes%2C%20warm%20cinematic%20lighting%2C%20professional%20film%20crew%20environment&width=800&height=450&seq=vid-thumb-06&orientation=landscape',
    duration: '09:50',
    views: 2150000,
    date: '2026-08-04',
    description: '正在热播的古装大剧男主角被多名剧组工作人员匿名爆料，称其在片场态度傲慢、不配合拍摄，甚至有工作人员因此辞职。',
    content: '<p>近日，正在热播的大型古装剧《XX传》的男主角被多名剧组工作人员匿名爆料，称其在拍摄期间态度恶劣，给整个剧组带来了极大的困扰。</p><p>据一位不愿透露姓名的剧组成员透露，该男演员经常迟到，有时甚至让全组人员等待两三个小时。在拍摄过程中，他对剧本频繁提出不合理的修改要求，导致拍摄进度严重延误。</p><p>另一位工作人员表示，该演员对群演和工作人员的态度尤其差，曾经因为盒饭不合口味而当众发火，导致一名负责订餐的工作人员当场辞职。</p><p>不过也有声音认为，作为一线明星档期紧张是常态，部分要求可能被夸大了。该演员经纪团队对此回应称"一切以作品说话，请大家关注作品本身"。</p><p>事件引发网友对明星片场行为的热烈讨论，#演员耍大牌#话题迅速登上热搜。</p>',
    tags: ['古装剧', '演员', '片场风波', '娱乐新闻'],
    isHot: false,
    isNew: true,
  },
  {
    id: 7,
    title: '某省会城市地铁工程被曝偷工减料，举报人遭威胁不敢现身',
    slug: 'metro-project-quality-scandal',
    category: 'social',
    thumbnail: 'https://readdy.ai/api/search-image?query=Underground%20metro%20construction%20site%20with%20concrete%20tunnel%2C%20industrial%20investigation%20scene%2C%20dramatic%20lighting%2C%20infrastructure%20project%20environment%2C%20warm%20dark%20tones&width=800&height=450&seq=vid-thumb-07&orientation=landscape',
    duration: '18:30',
    views: 5120000,
    date: '2026-08-04',
    description: '匿名举报人向媒体提供大量证据，指控某省会城市地铁建设项目存在严重偷工减料行为，举报人称已收到多次威胁。',
    content: '<p>近日，本平台收到一份来自匿名举报人的详细举报材料，指控某省会城市正在建设的地铁线路存在严重的偷工减料问题。</p><p>举报材料中包含了大量的施工照片、材料采购单据和内部通讯记录。材料显示，涉事标段的施工单位在混凝土配比、钢筋规格、防水材料等多个关键环节存在以次充好的行为，部分位置的工程质量严重不达标。</p><p>举报人在材料中自称是该项目的一名技术人员，因无法忍受良心谴责而选择举报。但举报人也表示，在提交举报材料前已多次收到不明身份的威胁电话和短信，目前已不敢回家，处于临时躲避状态。</p><p>该消息一经发布，引发社会广泛关注。当地住建部门已回应称"高度重视，正在组织专家进行核查"。涉事施工单位则发表声明否认所有指控，称举报材料系"恶意中伤"。</p><p>地铁工程安全关乎千家万户，此事进展将持续关注。</p>',
    tags: ['地铁工程', '工程质量', '举报', '社会热点'],
    isHot: false,
    isNew: true,
  },
  {
    id: 8,
    title: '知名女星离婚内幕曝光：财产分割达数亿，抚养权争夺白热化',
    slug: 'actress-divorce-inside-story',
    category: 'celebrity',
    thumbnail: 'https://readdy.ai/api/search-image?query=Luxurious%20mansion%20exterior%20at%20dusk%20with%20dramatic%20lighting%2C%20celebrity%20lifestyle%20scene%2C%20warm%20golden%20hour%20tones%2C%20editorial%20photography%2C%20high-end%20residential%20atmosphere&width=800&height=450&seq=vid-thumb-08&orientation=landscape',
    duration: '14:20',
    views: 6350000,
    date: '2026-08-03',
    description: '娱乐圈又一桩豪门婚变！知名女星与富商丈夫离婚案最新进展曝光，涉及数亿财产分割和子女抚养权争夺。',
    content: '<p>娱乐圈又一对"明星+富豪"组合走到尽头！知名女演员李某某与富商丈夫王某某的离婚案近日在法院进行了第三次调解，更多内幕随之曝光。</p><p>据知情人士透露，双方争议焦点主要集中在两方面：一是数亿元的夫妻共同财产分割，其中包括位于北京、上海、三亚等地的多套豪宅，以及多处商业地产和股权投资；二是两名未成年子女的抚养权归属。</p><p>女方律师主张，婚姻存续期间男方存在多次出轨行为，应少分财产。男方律师则反驳称，女方在婚后对家庭贡献有限，大部分财产系男方婚前积累和个人努力所得。</p><p>更引人关注的是，女方在最新提交的诉讼材料中，要求获得独立抚养权和每月200万元人民币的抚养费，这一数额刷新了娱乐圈抚养费记录。</p><p>业内人士分析认为，此案件若不能达成调解，将可能成为近年来娱乐圈涉案金额最大的离婚诉讼。</p>',
    tags: ['女星', '离婚', '财产分割', '抚养权'],
    isHot: false,
    isNew: false,
  },
  {
    id: 9,
    title: '百万粉丝博主被曝数据造假，真实互动率不足1%震惊行业',
    slug: 'influencer-data-fraud-exposed',
    category: 'influencer',
    thumbnail: 'https://readdy.ai/api/search-image?query=Digital%20analytics%20dashboard%20with%20social%20media%20metrics%20on%20screen%2C%20modern%20office%20setup%2C%20warm%20screen%20glow%2C%20data%20investigation%20scene%2C%20professional%20atmosphere&width=800&height=450&seq=vid-thumb-09&orientation=landscape',
    duration: '11:05',
    views: 1850000,
    date: '2026-08-03',
    description: '一份第三方数据监测报告显示，某拥有百万粉丝的头部博主真实活跃粉丝不足万人，绝大多数互动数据系刷量所得。',
    content: '<p>一份来自第三方数据监测机构的报告近日在营销圈引发地震。报告显示，某在社交平台拥有超过300万粉丝的头部生活方式博主，其真实活跃粉丝数量可能不足1万人，惊人的数据造假比例令整个行业哗然。</p><p>该报告通过对比该博主账号的点赞、评论、转发等互动数据与平台整体基准水平，发现其数据存在明显的异常模式。例如，该博主发布内容后，点赞数总能在极短时间内迅速飙升到数万，但评论区的真实用户互动（排除重复内容和无意义emoji）却少得可怜。</p><p>进一步分析发现，该博主90%以上的粉丝账号呈现出"僵尸粉"特征：无头像、无原创内容、关注大量账号但互动极少。保守估计，该博主在刷量服务上的投入每年超过百万元。</p><p>消息曝光后，多个曾与其合作的品牌方表示震惊，部分品牌已暂停与该博主的合作并考虑追究其违约责任。该博主本人的账号截至目前已设为私密状态。</p>',
    tags: ['网红', '数据造假', '粉丝经济', '行业乱象'],
    isHot: false,
    isNew: false,
  },
  {
    id: 10,
    title: '最新智能手机发布会前原型机泄露，设计颠覆行业认知',
    slug: 'new-smartphone-prototype-leaked',
    category: 'tech',
    thumbnail: 'https://readdy.ai/api/search-image?query=Futuristic%20smartphone%20prototype%20on%20dark%20desk%20with%20dramatic%20product%20lighting%2C%20technology%20leak%20scene%2C%20warm%20dark%20atmosphere%2C%20product%20photography%20style&width=800&height=450&seq=vid-thumb-10&orientation=landscape',
    duration: '07:45',
    views: 3560000,
    date: '2026-08-02',
    description: '某头部手机品牌即将发布的最新旗舰机型原型机在发布会前一周意外泄露，全新设计语言引发业界强烈关注。',
    content: '<p>距离某头部手机品牌的年度旗舰发布会仅剩一周时间，网络上却突然出现了大量据称是该机型的原型机实拍照片和上手视频。</p><p>从泄露的图片来看，这款新机采用了全新的设计语言，最引人注目的是其采用了屏下摄像头技术，实现了真正的全面屏效果。机身背部则采用了全新的材质工艺，据称是某种新型陶瓷复合材料，在手感和耐用性上都有显著提升。</p><p>硬件配置方面，爆料者称该机将首发搭载下一代旗舰处理器，配备全新的影像系统，主摄像头传感器尺寸达到1英寸级别。更重要的是，该机可能将率先取消物理充电接口，全面转向无线充电。</p><p>对于此次泄露事件，该品牌尚未做出官方回应。但业内人士分析认为，如此大规模的精准泄露，不排除是品牌方的"有意为之"，目的是在发布会前制造话题热度。</p>',
    tags: ['智能手机', '原型机泄露', '科技新品', '发布会'],
    isHot: false,
    isNew: false,
  },
  {
    id: 11,
    title: '知名连锁餐饮品牌后厨卫生状况触目惊心，外卖平台紧急下架',
    slug: 'restaurant-chain-hygiene-scandal',
    category: 'social',
    thumbnail: 'https://readdy.ai/api/search-image?query=Dark%20restaurant%20kitchen%20interior%20with%20dirty%20surfaces%2C%20investigative%20journalism%20scene%2C%20dramatic%20lighting%2C%20food%20safety%20inspection%20atmosphere%2C%20warm%20dark%20tones&width=800&height=450&seq=vid-thumb-11&orientation=landscape',
    duration: '16:40',
    views: 4780000,
    date: '2026-08-02',
    description: '暗访记者卧底某全国连锁餐饮品牌后厨一个月，拍下令人震惊的画面，食材过期、蟑螂横行、卫生状况堪忧。',
    content: '<p>本平台暗访记者以打工者身份进入某全国知名连锁餐饮品牌的一家门店后厨，进行了为期一个月的卧底调查，拍摄到的画面令人触目惊心。</p><p>在卧底期间，记者发现该后厨存在多项严重食品安全问题：过期食材照常使用，厨师将明显变质的肉类经过重口味调料处理后继续出餐；后厨蟑螂随处可见，甚至在食材储存区也发现了老鼠活动的痕迹；员工个人卫生习惯极差，多人上完厕所后不洗手就直接处理食材。</p><p>更令人震惊的是，该门店的管理层对此心知肚明。当记者以新员工身份提出卫生疑问时，后厨主管直接表示"别多管闲事，出了问题有上面顶着"。</p><p>报道发布后引发轩然大波，多个外卖平台紧急下架该品牌所有门店。当地市场监管部门已启动全面调查，该品牌总部发表道歉声明，承诺将进行全面整改。</p>',
    tags: ['食品安全', '后厨曝光', '连锁餐饮', '暗访调查'],
    isHot: false,
    isNew: false,
  },
  {
    id: 12,
    title: '当红小生被曝学历造假，经纪公司火速发声明否认但疑点重重',
    slug: 'actor-education-fraud-allegation',
    category: 'entertainment',
    thumbnail: 'https://readdy.ai/api/search-image?query=Dramatic%20spotlight%20on%20empty%20stage%20with%20graduation%20cap%20symbol%2C%20entertainment%20industry%20controversy%20scene%2C%20warm%20theatrical%20lighting%2C%20editorial%20photography&width=800&height=450&seq=vid-thumb-12&orientation=landscape',
    duration: '13:15',
    views: 2890000,
    date: '2026-08-01',
    description: '有网友扒出当红小生公开资料中的学历信息与实际情况严重不符，经纪公司声明澄清但多个疑点仍待解答。',
    content: '<p>近日，有网友在某高校校友数据库中查询发现，当红青年演员张某某公开资料中所称的"北京电影学院表演系本科毕业"学历存在重大疑点。</p><p>据调查，该校该届表演系本科毕业生名单中并无此人。进一步查询发现，该演员实际上仅在该校的成人教育学院进修过一年，并未取得本科学位证书。</p><p>面对质疑，该演员经纪公司在事发后24小时内火速发布声明，称"张某某确实曾在北京电影学院学习"，但未明确回应学历层次的问题。这种模糊的表述反而引发了更多质疑。</p><p>法律界人士指出，如果该演员在商业合作中明确使用了虚假学历信息进行宣传，可能构成欺诈行为，合作品牌方有权追责。目前已有两个正在与该演员合作的品牌表示正在核实情况。</p>',
    tags: ['演员', '学历造假', '娱乐新闻', '诚信问题'],
    isHot: false,
    isNew: false,
  },
];

export const getVideosByCategory = (category: string): VideoArticle[] => {
  return videos.filter((v) => v.category === category);
};

export const getHotVideos = (): VideoArticle[] => {
  return videos.filter((v) => v.isHot);
};

export const getNewVideos = (): VideoArticle[] => {
  return videos.filter((v) => v.isNew);
};

export const getVideoById = (id: number): VideoArticle | undefined => {
  return videos.find((v) => v.id === id);
};

export const getRelatedVideos = (currentId: number, category: string, limit: number = 4): VideoArticle[] => {
  return videos.filter((v) => v.id !== currentId && v.category === category).slice(0, limit);
};